
import merge from 'lodash.merge'

export const MINUTE = 60 * 1000
export const HOUR = 60 * MINUTE
export const DAY = 24 * HOUR
export const MONTH = 30 * DAY

export class Storage {
  constructor({ prefix, backend }={}) {
    this.delimiter = '::'
    this.prefix = prefix || ''
    this.backend = backend || window.localStorage
  }

  getPrefix() {
    return `${this.prefix}${this.delimiter}`
  }

  constructKey(key) {
    return `${this.getPrefix()}${key}`
  }

  checkKey(key) {
    return key.startsWith(this.getPrefix())
  }

  removeItem(key) {
    key = this.checkKey(key) ? key : this.constructKey(key)

    return this.backend.removeItem(key)
  }

  getItem(key) {
    let object = this.backend.getItem(this.constructKey(key))

    if (typeof object === 'undefined' || object === null) {
      return null
    }

    try {
      object = JSON.parse(object)
    } catch(e) {
      return null
    }

    let now = (new Date()).getTime()

    if (object.expired !== null && object.expired < now) {
      this.removeItem(key)

      return null
    }

    return object.$value
  }

  setItem(key, value, { expired }={}) {
    let now = (new Date()).getTime()
    expired = expired || null

    if (expired instanceof Date) {
      expired = expired - now
    } else if (expired !== null) {
      expired += now
    }

    return this.backend.setItem(this.constructKey(key), JSON.stringify({
      $value: value,
      expired
    }))
  }

  keys() {
    let keys = []

    for (var i = this.backend.length - 1; i >= 0; i--) {
      let key = this.backend.key(i)

      if (this.checkKey(key)) {
        keys.push(key)
      }
    }

    return keys
  }

  clean() {
    for (let key of this.keys()) {
      this.removeItem(key)
    }
  }
}


export class AutoExpirationStorage extends Storage {
  constructor({ prefix, backend, expiration }={}) {
    super({ prefix, backend })

    this.expiration = expiration || DAY
  }

  setItem(key, value, { expired }={}) {
    if (typeof expired == 'undefined' || !expired) {
      expired = this.expiration
    }

    return super.setItem(key, value, { expired })
  }
}


export const storage = new Storage({
  prefix: `application-${window.$currentLanguage}`,
})



// WEBPACK FOOTER //
// ./src/js/shared/utils/storage.js